import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
import { deepFlatten } from '@applyboard/ui-utils';
var classNames = function classNames() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return deepFlatten(args).filter(function (e) {
    return !!e && typeof e === 'string' && e.trim().length > 0;
  }).map(function (e) {
    return e.trim();
  }).join(' ');
};
export default classNames;